import React from 'react';
import { Shield, Lock, Eye } from 'lucide-react';
import { Card } from '@/components/ui/card';

export default function PrivacyNotice() {
  return (
    <Card className="p-4 bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-100">
      <div className="flex items-start gap-3">
        <Shield className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="font-semibold text-blue-900 text-sm mb-2">Tu privacidad está protegida</h3>
          <ul className="space-y-1 text-xs text-blue-700">
            <li className="flex items-center gap-2">
              <Lock className="w-3 h-3" />
              <span>Tus productos escaneados son privados</span>
            </li>
            <li className="flex items-center gap-2">
              <Eye className="w-3 h-3" />
              <span>Solo tú puedes ver tu historial y estadísticas</span>
            </li>
            <li className="flex items-center gap-2">
              <Shield className="w-3 h-3" />
              <span>Tu perfil de salud es confidencial</span>
            </li>
          </ul>
        </div>
      </div>
    </Card>
  );
}